<template>
  <div class="min-h-screen bg-navy flex items-center justify-center p-4 relative overflow-hidden">
    <!-- Background decoration blobs -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none">
      <div class="absolute -top-32 -right-32 w-96 h-96 bg-teal/10 rounded-full blur-3xl"></div>
      <div class="absolute -bottom-32 -left-32 w-96 h-96 bg-teal/5 rounded-full blur-3xl"></div>
    </div>

    <!-- Lab particles background -->
    <div class="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">

      <!-- Fiole / Erlenmeyer -->
      <svg class="lab-particle" style="left:5%;top:15%;animation-delay:0s;animation-duration:18s;width:48px;height:48px" viewBox="0 0 48 48" fill="none">
        <path d="M18 6h12M19 6v14L8 38a3 3 0 002.5 4.5h27A3 3 0 0040 38L29 20V6" stroke="#2DD4BF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="16" cy="34" r="2" fill="#2DD4BF" opacity="0.6"/>
        <circle cx="26" cy="38" r="1.5" fill="#2DD4BF" opacity="0.4"/>
        <circle cx="32" cy="32" r="1" fill="#2DD4BF" opacity="0.5"/>
      </svg>

      <!-- Tube à essai -->
      <svg class="lab-particle" style="left:80%;top:20%;animation-delay:2s;animation-duration:20s;width:36px;height:56px" viewBox="0 0 36 56" fill="none">
        <rect x="12" y="2" width="12" height="38" rx="6" stroke="#2DD4BF" stroke-width="2"/>
        <path d="M12 32h12" stroke="#2DD4BF" stroke-width="1.5" opacity="0.5"/>
        <path d="M12 38h12" stroke="#2DD4BF" stroke-width="1.5" opacity="0.3"/>
        <rect x="10" y="2" width="16" height="5" rx="2" stroke="#2DD4BF" stroke-width="1.5"/>
        <circle cx="18" cy="35" r="2" fill="#2DD4BF" opacity="0.5"/>
      </svg>

      <!-- Molécule -->
      <svg class="lab-particle" style="left:20%;top:70%;animation-delay:4s;animation-duration:22s;width:60px;height:60px" viewBox="0 0 60 60" fill="none">
        <circle cx="30" cy="30" r="6" stroke="#2DD4BF" stroke-width="2"/>
        <circle cx="10" cy="15" r="4" stroke="#2DD4BF" stroke-width="1.5"/>
        <circle cx="50" cy="15" r="4" stroke="#2DD4BF" stroke-width="1.5"/>
        <circle cx="10" cy="45" r="4" stroke="#2DD4BF" stroke-width="1.5"/>
        <circle cx="50" cy="45" r="4" stroke="#2DD4BF" stroke-width="1.5"/>
        <line x1="14" y1="18" x2="25" y2="26" stroke="#2DD4BF" stroke-width="1.5" opacity="0.7"/>
        <line x1="46" y1="18" x2="35" y2="26" stroke="#2DD4BF" stroke-width="1.5" opacity="0.7"/>
        <line x1="14" y1="42" x2="25" y2="34" stroke="#2DD4BF" stroke-width="1.5" opacity="0.7"/>
        <line x1="46" y1="42" x2="35" y2="34" stroke="#2DD4BF" stroke-width="1.5" opacity="0.7"/>
      </svg>

      <!-- Microscope simplifié -->
      <svg class="lab-particle" style="left:65%;top:65%;animation-delay:6s;animation-duration:19s;width:44px;height:56px" viewBox="0 0 44 56" fill="none">
        <rect x="18" y="2" width="8" height="20" rx="2" stroke="#2DD4BF" stroke-width="2"/>
        <circle cx="22" cy="6" r="3" stroke="#2DD4BF" stroke-width="1.5"/>
        <path d="M14 22h16" stroke="#2DD4BF" stroke-width="2" stroke-linecap="round"/>
        <path d="M22 22v8" stroke="#2DD4BF" stroke-width="2"/>
        <path d="M16 30h12" stroke="#2DD4BF" stroke-width="1.5"/>
        <path d="M10 44h24" stroke="#2DD4BF" stroke-width="2" stroke-linecap="round"/>
        <path d="M16 44v-6h12v6" stroke="#2DD4BF" stroke-width="1.5"/>
      </svg>

      <!-- Pipette -->
      <svg class="lab-particle" style="left:88%;top:55%;animation-delay:1s;animation-duration:16s;width:28px;height:64px" viewBox="0 0 28 64" fill="none">
        <path d="M14 2v40" stroke="#2DD4BF" stroke-width="2" stroke-linecap="round"/>
        <path d="M8 42h12l-6 18-6-18z" stroke="#2DD4BF" stroke-width="1.5" stroke-linejoin="round"/>
        <rect x="8" y="6" width="12" height="8" rx="2" stroke="#2DD4BF" stroke-width="1.5"/>
        <circle cx="14" cy="56" r="2" fill="#2DD4BF" opacity="0.6"/>
      </svg>

      <!-- Capsule / Pilule -->
      <svg class="lab-particle" style="left:40%;top:8%;animation-delay:8s;animation-duration:24s;width:52px;height:24px" viewBox="0 0 52 24" fill="none">
        <rect x="2" y="2" width="48" height="20" rx="10" stroke="#2DD4BF" stroke-width="2"/>
        <line x1="26" y1="2" x2="26" y2="22" stroke="#2DD4BF" stroke-width="1.5" opacity="0.6"/>
        <rect x="2" y="2" width="24" height="20" rx="10" fill="#2DD4BF" fill-opacity="0.12"/>
      </svg>

      <!-- Atome -->
      <svg class="lab-particle" style="left:12%;top:40%;animation-delay:5s;animation-duration:21s;width:56px;height:56px" viewBox="0 0 56 56" fill="none">
        <circle cx="28" cy="28" r="4" fill="#2DD4BF" opacity="0.8"/>
        <ellipse cx="28" cy="28" rx="24" ry="10" stroke="#2DD4BF" stroke-width="1.5" opacity="0.6"/>
        <ellipse cx="28" cy="28" rx="24" ry="10" stroke="#2DD4BF" stroke-width="1.5" opacity="0.6" transform="rotate(60 28 28)"/>
        <ellipse cx="28" cy="28" rx="24" ry="10" stroke="#2DD4BF" stroke-width="1.5" opacity="0.6" transform="rotate(120 28 28)"/>
      </svg>

      <!-- Fiole ronde -->
      <svg class="lab-particle" style="left:50%;top:80%;animation-delay:3s;animation-duration:17s;width:44px;height:52px" viewBox="0 0 44 52" fill="none">
        <path d="M16 4h12" stroke="#2DD4BF" stroke-width="2" stroke-linecap="round"/>
        <path d="M18 4v12L6 38a16 16 0 1032 0L26 16V4" stroke="#2DD4BF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 38h24" stroke="#2DD4BF" stroke-width="1.5" opacity="0.4"/>
        <circle cx="16" cy="42" r="2" fill="#2DD4BF" opacity="0.5"/>
        <circle cx="28" cy="44" r="1.5" fill="#2DD4BF" opacity="0.4"/>
      </svg>

      <!-- Tube gradué -->
      <svg class="lab-particle" style="left:72%;top:10%;animation-delay:9s;animation-duration:23s;width:24px;height:60px" viewBox="0 0 24 60" fill="none">
        <rect x="4" y="2" width="16" height="52" rx="8" stroke="#2DD4BF" stroke-width="2"/>
        <line x1="10" y1="20" x2="16" y2="20" stroke="#2DD4BF" stroke-width="1.5" opacity="0.6"/>
        <line x1="8" y1="30" x2="16" y2="30" stroke="#2DD4BF" stroke-width="1.5" opacity="0.6"/>
        <line x1="10" y1="40" x2="16" y2="40" stroke="#2DD4BF" stroke-width="1.5" opacity="0.6"/>
        <rect x="4" y="38" width="16" height="16" rx="8" fill="#2DD4BF" fill-opacity="0.2"/>
      </svg>

      <!-- Hexagone moléculaire -->
      <svg class="lab-particle" style="left:33%;top:50%;animation-delay:7s;animation-duration:20s;width:48px;height:48px" viewBox="0 0 48 48" fill="none">
        <polygon points="24,4 42,14 42,34 24,44 6,34 6,14" stroke="#2DD4BF" stroke-width="2" fill="none"/>
        <polygon points="24,14 32,19 32,29 24,34 16,29 16,19" stroke="#2DD4BF" stroke-width="1.5" fill="#2DD4BF" fill-opacity="0.1"/>
        <circle cx="24" cy="24" r="3" fill="#2DD4BF" opacity="0.7"/>
      </svg>

      <!-- Boîte de stock / carton -->
      <svg class="lab-particle" style="left:3%;top:80%;animation-delay:2.5s;animation-duration:19s;width:52px;height:48px" viewBox="0 0 52 48" fill="none">
        <rect x="4" y="16" width="44" height="28" rx="3" stroke="#2DD4BF" stroke-width="2"/>
        <path d="M4 24h44" stroke="#2DD4BF" stroke-width="1.5" opacity="0.5"/>
        <path d="M18 16V8h16v8" stroke="#2DD4BF" stroke-width="2" stroke-linejoin="round"/>
        <path d="M18 8h16" stroke="#2DD4BF" stroke-width="1.5"/>
        <line x1="26" y1="28" x2="26" y2="40" stroke="#2DD4BF" stroke-width="1.5" opacity="0.5"/>
        <line x1="20" y1="34" x2="32" y2="34" stroke="#2DD4BF" stroke-width="1.5" opacity="0.5"/>
      </svg>

      <!-- Graphique en barres (stock) -->
      <svg class="lab-particle" style="left:57%;top:30%;animation-delay:10s;animation-duration:23s;width:52px;height:48px" viewBox="0 0 52 48" fill="none">
        <line x1="6" y1="42" x2="46" y2="42" stroke="#2DD4BF" stroke-width="2" stroke-linecap="round"/>
        <line x1="6" y1="6" x2="6" y2="42" stroke="#2DD4BF" stroke-width="2" stroke-linecap="round"/>
        <rect x="10" y="28" width="8" height="14" rx="1" stroke="#2DD4BF" stroke-width="1.5" fill="#2DD4BF" fill-opacity="0.2"/>
        <rect x="22" y="18" width="8" height="24" rx="1" stroke="#2DD4BF" stroke-width="1.5" fill="#2DD4BF" fill-opacity="0.2"/>
        <rect x="34" y="10" width="8" height="32" rx="1" stroke="#2DD4BF" stroke-width="1.5" fill="#2DD4BF" fill-opacity="0.3"/>
      </svg>

      <!-- Bon de commande / document -->
      <svg class="lab-particle" style="left:90%;top:35%;animation-delay:4.5s;animation-duration:21s;width:40px;height:52px" viewBox="0 0 40 52" fill="none">
        <rect x="4" y="4" width="32" height="44" rx="3" stroke="#2DD4BF" stroke-width="2"/>
        <path d="M10 14h20" stroke="#2DD4BF" stroke-width="1.5" stroke-linecap="round" opacity="0.7"/>
        <path d="M10 22h20" stroke="#2DD4BF" stroke-width="1.5" stroke-linecap="round" opacity="0.7"/>
        <path d="M10 30h14" stroke="#2DD4BF" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/>
        <path d="M10 38h10" stroke="#2DD4BF" stroke-width="1.5" stroke-linecap="round" opacity="0.4"/>
        <path d="M28 4v8h8" stroke="#2DD4BF" stroke-width="1.5" stroke-linejoin="round" opacity="0.6"/>
      </svg>

      <!-- Flèche de transfert / dispatch -->
      <svg class="lab-particle" style="left:25%;top:90%;animation-delay:11s;animation-duration:18s;width:56px;height:36px" viewBox="0 0 56 36" fill="none">
        <rect x="2" y="10" width="20" height="16" rx="2" stroke="#2DD4BF" stroke-width="1.5"/>
        <rect x="34" y="10" width="20" height="16" rx="2" stroke="#2DD4BF" stroke-width="1.5"/>
        <path d="M22 18h12" stroke="#2DD4BF" stroke-width="2" stroke-linecap="round"/>
        <path d="M30 12l6 6-6 6" stroke="#2DD4BF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="12" cy="18" r="3" fill="#2DD4BF" fill-opacity="0.3" stroke="#2DD4BF" stroke-width="1"/>
        <circle cx="44" cy="18" r="3" fill="#2DD4BF" fill-opacity="0.3" stroke="#2DD4BF" stroke-width="1"/>
      </svg>

      <!-- Étiquette / tag produit -->
      <svg class="lab-particle" style="left:45%;top:45%;animation-delay:13s;animation-duration:22s;width:48px;height:44px" viewBox="0 0 48 44" fill="none">
        <path d="M4 4h20l20 18-20 18H4V4z" stroke="#2DD4BF" stroke-width="2" stroke-linejoin="round"/>
        <circle cx="12" cy="14" r="3" stroke="#2DD4BF" stroke-width="1.5"/>
        <line x1="18" y1="22" x2="34" y2="22" stroke="#2DD4BF" stroke-width="1.5" opacity="0.6"/>
        <line x1="18" y1="28" x2="30" y2="28" stroke="#2DD4BF" stroke-width="1.5" opacity="0.4"/>
      </svg>

      <!-- Entrepôt / warehouse simplifié -->
      <svg class="lab-particle" style="left:75%;top:85%;animation-delay:6.5s;animation-duration:25s;width:60px;height:48px" viewBox="0 0 60 48" fill="none">
        <path d="M4 24L30 6l26 18" stroke="#2DD4BF" stroke-width="2" stroke-linejoin="round"/>
        <rect x="8" y="24" width="44" height="20" rx="1" stroke="#2DD4BF" stroke-width="2"/>
        <rect x="22" y="30" width="16" height="14" rx="1" stroke="#2DD4BF" stroke-width="1.5"/>
        <line x1="30" y1="30" x2="30" y2="44" stroke="#2DD4BF" stroke-width="1" opacity="0.5"/>
        <line x1="14" y1="28" x2="14" y2="44" stroke="#2DD4BF" stroke-width="1" opacity="0.3"/>
        <line x1="46" y1="28" x2="46" y2="44" stroke="#2DD4BF" stroke-width="1" opacity="0.3"/>
      </svg>

      <!-- QR code / code-barres -->
      <svg class="lab-particle" style="left:15%;top:5%;animation-delay:14s;animation-duration:20s;width:44px;height:44px" viewBox="0 0 44 44" fill="none">
        <rect x="4" y="4" width="14" height="14" rx="1" stroke="#2DD4BF" stroke-width="1.5"/>
        <rect x="26" y="4" width="14" height="14" rx="1" stroke="#2DD4BF" stroke-width="1.5"/>
        <rect x="4" y="26" width="14" height="14" rx="1" stroke="#2DD4BF" stroke-width="1.5"/>
        <rect x="7" y="7" width="8" height="8" fill="#2DD4BF" fill-opacity="0.4"/>
        <rect x="29" y="7" width="8" height="8" fill="#2DD4BF" fill-opacity="0.4"/>
        <rect x="7" y="29" width="8" height="8" fill="#2DD4BF" fill-opacity="0.4"/>
        <line x1="26" y1="26" x2="26" y2="30" stroke="#2DD4BF" stroke-width="1.5"/>
        <line x1="30" y1="26" x2="30" y2="30" stroke="#2DD4BF" stroke-width="1.5"/>
        <line x1="34" y1="26" x2="34" y2="30" stroke="#2DD4BF" stroke-width="1.5"/>
        <line x1="38" y1="26" x2="38" y2="30" stroke="#2DD4BF" stroke-width="1.5"/>
        <line x1="26" y1="34" x2="26" y2="40" stroke="#2DD4BF" stroke-width="1.5"/>
        <line x1="32" y1="34" x2="32" y2="40" stroke="#2DD4BF" stroke-width="1.5"/>
        <line x1="38" y1="34" x2="38" y2="40" stroke="#2DD4BF" stroke-width="1.5"/>
      </svg>

    </div>

    <div class="relative z-10 w-full max-w-md">
      <!-- Logo + title -->
      <div class="text-center mb-8">
        <div class="w-16 h-16 bg-offwhite rounded-2xl mx-auto flex items-center justify-center shadow-xl mb-4">
          <img src="/src/assets/enval.png" alt="Smart LabStock" class="w-12 h-12 object-contain" onerror="this.style.display='none'" />
          <i class="pi pi-flask text-navy text-2xl" style="display:none"></i>
        </div>
        <h1 class="text-2xl font-bold text-offwhite">Smart LabStock</h1>
        <p class="text-offwhite/50 text-sm mt-1">Gestion intelligente des stocks de laboratoire</p>
      </div>

      <!-- Login card -->
      <div class="bg-offwhite rounded-[24px] p-8 shadow-2xl">
        <h2 class="text-navy font-bold text-lg mb-6">Connexion</h2>

        <form @submit.prevent="handleLogin" class="space-y-5" novalidate>
          <!-- Email -->
          <div class="flex flex-col gap-1.5">
            <label for="email" class="text-navy/70 text-xs font-semibold uppercase tracking-wide">
              Adresse email
            </label>
            <input
              id="email"
              v-model="credentials.email"
              type="email"
              placeholder="votre@email.com"
              autocomplete="email"
              :class="[
                'w-full bg-white border rounded-xl px-4 py-3 text-sm text-navy outline-none transition-all',
                'placeholder:text-navy/30',
                errors.email
                  ? 'border-red-400 focus:ring-2 focus:ring-red-400/20'
                  : 'border-[#D0CABC] focus:border-teal focus:ring-2 focus:ring-teal/20'
              ]"
            />
            <p v-if="errors.email" class="text-red-500 text-xs">{{ errors.email }}</p>
          </div>

          <!-- Password -->
          <div class="flex flex-col gap-1.5">
            <label for="password" class="text-navy/70 text-xs font-semibold uppercase tracking-wide">
              Mot de passe
            </label>
            <div class="relative">
              <input
                id="password"
                v-model="credentials.password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="••••••••"
                autocomplete="current-password"
                :class="[
                  'w-full bg-white border rounded-xl px-4 py-3 pr-11 text-sm text-navy outline-none transition-all',
                  'placeholder:text-navy/30',
                  errors.password
                    ? 'border-red-400 focus:ring-2 focus:ring-red-400/20'
                    : 'border-[#D0CABC] focus:border-teal focus:ring-2 focus:ring-teal/20'
                ]"
              />
              <button
                type="button"
                @click="showPassword = !showPassword"
                class="absolute right-3 top-1/2 -translate-y-1/2 text-navy/40 hover:text-navy transition-colors"
                tabindex="-1"
              >
                <i :class="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'" class="text-sm"></i>
              </button>
            </div>
            <p v-if="errors.password" class="text-red-500 text-xs">{{ errors.password }}</p>
          </div>

          <!-- Remember + forgot -->
          <div class="flex items-center justify-between">
            <label class="flex items-center gap-2 cursor-pointer select-none">
              <div
                @click="credentials.remember = !credentials.remember"
                :class="[
                  'w-4 h-4 rounded border-2 flex items-center justify-center transition-all',
                  credentials.remember ? 'bg-teal border-teal' : 'bg-white border-[#D0CABC] hover:border-teal'
                ]"
              >
                <i v-if="credentials.remember" class="pi pi-check text-offwhite text-[9px]"></i>
              </div>
              <span class="text-sm text-navy/60">Se souvenir de moi</span>
            </label>
            <router-link
              to="/forgot-password"
              class="text-sm text-teal hover:text-teal/80 font-medium transition-colors"
            >
              Mot de passe oublié ?
            </router-link>
          </div>

          <!-- Error message -->
          <div v-if="loginError" class="bg-red-50 border border-red-200 rounded-xl px-4 py-3 text-red-700 text-sm flex items-center gap-2">
            <i class="pi pi-exclamation-circle text-base flex-shrink-0"></i>
            {{ loginError }}
          </div>

          <!-- Submit -->
          <button
            type="submit"
            :disabled="loading"
            class="w-full bg-navy text-offwhite py-3 rounded-xl text-sm font-semibold hover:bg-navy-mid transition-all disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            <i v-if="loading" class="pi pi-spinner animate-spin text-sm"></i>
            <i v-else class="pi pi-sign-in text-sm"></i>
            {{ loading ? 'Connexion en cours...' : 'Se connecter' }}
          </button>
        </form>
      </div>

      <!-- Footer -->
      <p class="text-center text-offwhite/30 text-xs mt-6">
        &copy; 2025 Smart LabStock — Plateforme de gestion des stocks de laboratoire
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth.js'

const router = useRouter()
const authStore = useAuthStore()

const loading = ref(false)
const showPassword = ref(false)
const loginError = ref('')

const credentials = ref({
  email: '',
  password: '',
  remember: false
})

const errors = ref({ email: '', password: '' })

const validateForm = function() {
  errors.value = { email: '', password: '' }
  let valid = true

  if (!credentials.value.email) {
    errors.value.email = "L'adresse email est requise"
    valid = false
  } else if (!/\S+@\S+\.\S+/.test(credentials.value.email)) {
    errors.value.email = "L'adresse email n'est pas valide"
    valid = false
  }

  if (!credentials.value.password) {
    errors.value.password = 'Le mot de passe est requis'
    valid = false
  } else if (credentials.value.password.length < 6) {
    errors.value.password = 'Le mot de passe doit contenir au moins 6 caractères'
    valid = false
  }

  return valid
}

const handleLogin = async function() {
  loginError.value = ''
  if (!validateForm()) return

  loading.value = true
  try {
    const result = await authStore.login({
      email: credentials.value.email,
      password: credentials.value.password
    })

    if (result.success) {
      router.push(authStore.getDefaultDashboard())
    } else {
      loginError.value = result.message || 'Email ou mot de passe incorrect'
    }
  } catch (error) {
    console.error('Erreur connexion:', error)
    loginError.value = 'Une erreur inattendue s\'est produite. Veuillez réessayer.'
  } finally {
    loading.value = false
  }
}

onMounted(function() {
  if (authStore.isAuthenticated) {
    router.push(authStore.getDefaultDashboard())
  }
})
</script>

<style scoped>
@keyframes floatUp {
  0%   { transform: translateY(0px) rotate(0deg); opacity: 0.25; }
  25%  { transform: translateY(-25px) rotate(6deg); opacity: 0.35; }
  50%  { transform: translateY(-12px) rotate(-4deg); opacity: 0.20; }
  75%  { transform: translateY(-35px) rotate(8deg); opacity: 0.30; }
  100% { transform: translateY(0px) rotate(0deg); opacity: 0.25; }
}

.lab-particle {
  position: absolute;
  animation: floatUp ease-in-out infinite;
  opacity: 0.25;
}
</style>
